// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarRatings_stars__dlizu","active":"StarRatings_active__NnwAl"};